import React, { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { WhatIs } from './components/WhatIs';
import { Process } from './components/Process';
import { HowItWorksForYou } from './components/HowItWorksForYou';
import { ForWho } from './components/ForWho';
import { PoC } from './components/PoC';
import { Booking } from './components/Booking';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SEO } from './components/SEO';
export function App() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  return <div className="font-sans antialiased overflow-x-hidden min-h-screen flex flex-col" data-id="element-0" data-mp="28te37ebavbnm">
      <SEO data-id="element-1" data-mp="23w4clvc6cty7" />

      {/* Skip-to-content link voor toegankelijkheid + SEO */}
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:bg-brand-primary focus:text-white focus:px-4 focus:py-2 focus:rounded-lg focus:font-bold" data-id="element-2" data-mp="3ik7ekc2063oj">
        Direct naar de inhoud
      </a>

      {/* Scroll Progress Bar */}
      <motion.div className="scroll-progress" style={{
      scaleX
    }} data-id="element-3" data-mp="6hrlipoilfp" />

      <Nav data-id="element-4" data-mp="2zlv7cvunj3vl" />
      <main id="main" className="flex-grow" role="main" data-id="element-5" data-mp="2zm4xcjfp5b1a">
        <Hero data-id="element-6" data-mp="33movnqc0akp0" />
        <PainPoints data-id="element-7" data-mp="33m5am0r27g6r" />
        <WhatIs data-id="element-8" data-mp="33nq4do5juv3k" />
        <Process data-id="element-9" data-mp="33n6y54p9hv5d" />
        <HowItWorksForYou data-id="element-10" data-mp="33orjq4tlm3r3" />
        <ForWho data-id="element-11" data-mp="38m1gk5jbhhoy" />
        <PoC data-id="element-12" data-mp="38li8rhnds9on" />
        <Booking data-id="element-13" data-mp="38kqfwel64q22" />
        <FAQ data-id="element-14" data-mp="38k6wsujs7vmg" />
      </main>
      <Footer data-id="element-15" data-mp="38o4fjf2g6l5t" />
    </div>;
}